import { useContext } from "react";
import CacheContext from "contexts/CacheContext";

const useCacheId = () => useContext(CacheContext).cacheId;

export default useCacheId;
